import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import SelectMemberList from '../SelectMemberList';
import ExpandableSection from '../../../../../components/ExpandableSectionSettings';
import UserAvatarWithName from '../../../../../components/UserAvatar/UserAvatarWithName';
import dataModel from '../../../../../models/DataModel';
import LoadingDots from '../../../../../components/LoadingDots';
import teamIconBlue from '../../../../../assets/images/teams-icon-blue.svg';
import teamIcon from '../../../../../assets/images/teams-icon.svg';
import CollectionDataSource from '../../../../../dao/DataSource/CollectionDataSource';
import './TeamMembers.scss';
import Input from '../../../../../components/Input';

export class TeamMembers extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      menu: null, 
      editing: false,
      teamsCopy: null,
      teams: null,
      oldTeams: null,
      loadingTeams: true,
      searchString: '',
      members: null,
      searching: false,
    };

    this.createSelectedMemberList = this.createSelectedMemberList.bind(this);
    this.gotoDirectory = this.gotoDirectory.bind(this);
    this.handleTeamRetrieval = this.handleTeamRetrieval.bind(this);
    this.handleSearchTeams = this.handleSearchTeams.bind(this);

    this.handleGoAllTeams = this.handleGoAllTeams.bind(this);
    this.handleClearSearchBar = this.handleClearSearchBar.bind(this);
  
    //this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    
    const { project } = this.props;
    if (prevProps.requestClose != this.props.requestClose) {
      this.handleClose();
    } else {
      if (project && (!prevProps.project || prevProps.project.id != project.id)) {
        this.fetchData();
      }
    }
  }

  fetchData() {
    const { project, currentCompany } = this.props;
    if (project && currentCompany) {
      if (this.teamsDataSource) {
        this.teamsDataSource.release();
        this.teamsDataSource = null;
      }
      this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {}, users: {} } }, this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id, project.market_id);
      this.teamsDataSource.current();
    }
  }

  handleTeamRetrieval(teams, action, acData, fetchedData) {
    const { project } = this.props;

    if(teams.teams.length != 0) {
      if(!this.state.teamsCopy) {
        var newTeamsCopy = { ...teams, oldTeams: teams.teams };
        this.setState({ teamsCopy: newTeamsCopy });
      }
    }
    
    if(project && project.market_id){
      this.setState({ loadingTeams: action == 'prefetch', teams });
    }
    else{
      this.setState({ loadingTeams: action == 'prefetch', teams: null });
    }
  }

  isUser(member) {
    return member.first_name || member.last_name;
  }

  isTeamProjectMember(team) {
    const { projectMembers } = this.props;
    if (projectMembers) {
      const foundTeam = projectMembers.find((teamToCheck) => {
        if (!this.isUser(teamToCheck) && teamToCheck.id == team.id) {
          return true;
        } 
        else {
          return false;
        }
      }, this);
      return foundTeam != null;
    }
    return false;
  }

  createSelectedMemberList() {
    let selectedMembers = [];
    if (this.props.projectMembers) {
      selectedMembers = this.props.projectMembers.filter(member => {
        if ((member.first_name || member.last_name) && !member.name) {
          member.name = member.first_name + ' ' + member.last_name;
        }
        if (this.props.isBuildOwner || this.props.permissions.canEditProject) {
          if (member.companies && member.companies.length && member.companies[0].id == this.props.currentCompany.id) {
            return true;
          }
        }
        return true;
      }, this);
    }
    return selectedMembers;
  }
  handleGoAllTeams() {

    const { project, currentCompany } = this.props;
    if (project && currentCompany) {
      if (this.teamsDataSource) {
        this.teamsDataSource.release();
        this.teamsDataSource = null;
      }
      this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {}, users: {} } }, this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id, project.market_id);
      this.teamsDataSource.current();
    }

  }

  handleClearSearchBar(){
    var { searchString } = this.state;
    
    if(searchString != '') {

      this.setState({ searchString: '', searching: false });
      const { project, currentCompany } = this.props;
      if (project && currentCompany) {
        if (this.teamsDataSource) {
          this.teamsDataSource.release();
          this.teamsDataSource = null;
        }
        this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {}, users: {} } }, this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id, project.market_id);
        this.teamsDataSource.current();
      }
    }
  }

  handleSearchTeams(e) {
    var { teams, teamsCopy } = this.state;
    
    let query;
    query = e.target.value;
    this.setState({ searching: true, searchString: query });
    if (query) {
      const newTeams = teamsCopy && teamsCopy.teams && teamsCopy.teams.filter(m => m.name.toLowerCase().includes(query.toLowerCase())) || [];
      teams.teams = newTeams;
      this.setState({ teams: teams });

    }else {
      this.setState({ searching: false });
      const { project, currentCompany } = this.props;
      if (project && currentCompany) {
        if (this.teamsDataSource) {
          this.teamsDataSource.release();
          this.teamsDataSource = null;
        }
        this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {}, users: {} } }, this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id, project.market_id);
        this.teamsDataSource.current();
      }
      
    }
  }

  handleSelectMember(member) {
    if (this.props.handleAddMember) {
      this.setState(prevState => {
        const updatedTeams = prevState.teams.teams.map(team => {
          const indexOfMember = team.users.findIndex(user => user.id === member.id);
          if (indexOfMember !== -1) {
            const updatedTeam = { ...team };
            updatedTeam.users = [...team.users];
            updatedTeam.users.splice(indexOfMember, 1);
            return updatedTeam;
          }
          return team;
        });
        const newState = { ...prevState };
        newState.teams.teams = updatedTeams;
        return newState;
      }, () => {
        this.props.handleAddMember(member);
      });
    }
  }

  createTeamsList() {
    let { teams } = this.state;
    if (teams && teams.teams && teams.teams.length > 0) {
      teams = teams.teams.filter((team) => {
        return !this.isTeamProjectMember(team);
      }, this);
      return teams.map((team) => {
        const teamMembers = team.users.map((user) => {
          return (
       
              <UserAvatarWithName selectUser={this.handleSelectMember} onClear={this.handleClearSearchBar} key={user.id} user={user}/>
          
          );
        });
        return (
        
          <ExpandableSection
            initiallyExpanded={false}
            name={team.name}
            key={team.id}
            animateExpand={this.props.animateExpand}
            icon={team.logo || teamIconBlue}
            onClear={this.handleClearSearchBar}
            onClick={this.props.handleAddMember}
            onClickData={team}
          >
            <div  className="team-teams-members">
              { teamMembers }
              
            </div>

          </ExpandableSection>
       
        );
      });
    }
    return null;
  }

  cancelChange = () => {
    dataModel.systemPopup = null;
  };

  gotoDirectory(e) {
    this.props.history.push('/directory/teams');
  }

  render() {
    let { project } = this.props;
    const { loadingTeams } = this.state;
    const { searching } = this.state;
    if (project == undefined) {
      return null;
    }
    const { currentUser, permissions } = this.props;
    let isAdmin = false;
    let isEditor = false;
    if (currentUser && permissions) {
      if (permissions.isSuperUser || currentUser.role.name == 'admin') {
        isAdmin = true;
      }
      else if (currentUser.role.name == 'editor') {
        isEditor = true;
      }
    }

    const selectedMembers = this.createSelectedMemberList();
    let teamList = this.createTeamsList();
    
    return (
          <div className="team-members-main-body">
            <div className="left-side">
              <div className="selection-section team-section">
                {/* {!teamList && !loadingTeams && !searching && 
                <div className="team-no-teams">
                  <div className="team-icon">
                    <img className='team-icon-img' src={teamIcon} alt='Teams' />
                  </div>
                  {(isEditor || isAdmin) &&
                  <div className="team-did-you-know">Did you know you can now create<br/>Teams in Active Oversight?</div>
                  }
                  {isAdmin &&
                  <div className="team-goto-directory">Go to the <a className="team-goto-directory-link" onClick={this.gotoDirectory}>Directory</a> to get started.</div>
                  }
                  {isEditor &&
                  <div className="team-goto-directory">Contact your company admin user to get started!</div>
                  }
                </div>
                } */}
          
                {/* {
                  !teamList && searching &&

                  <div className="team-teams">
                  <div className="label taller">Available Teams</div>
                  <div className="teams-team-list-scroller">
                    <div className="teams-team-list">
                    
                      <p>No found teams</p>
                    </div>
                  </div>
                  <div className="instructions">Click to Add</div>
                </div>
                  
                } */}
               
                { 
                <div className="team-teams">
                  <div className="label taller">Available Teams</div>
                  <div className="teams-team-list-scroller">
                    <div className="teams-team-list">
                  
                      <Input value={this.state.searchString} onChange={this.handleSearchTeams} placeholder='Search Available Teams' className='teams-search-input' type="text"  />
                   
                      {teamList &&  
                      teamList}
                        
                        {!teamList && searching &&

                        <p>No Teams Found...</p>

                        }

        {!teamList && !loadingTeams && !searching && 

<div className="team-no-teams">
                  <div className="team-icon">
                    <img className='team-icon-img' src={teamIcon} alt='Teams' />
                  </div>
                  {(isEditor || isAdmin) &&
                  <div className="team-did-you-know">Did you know you can now create<br/>Teams in Active Oversight?</div>
                  }
                  {isAdmin &&
                  <div className="team-goto-directory">Go to the <a className="team-goto-directory-link" onClick={this.gotoDirectory}>Directory</a> to get started.</div>
                  }
                  {isEditor &&
                  <div className="team-goto-directory">Contact your company admin user to get started!</div>
                  }
                </div>

}
                        
                    </div>
                  </div>
                  <div className="instructions">Click to Add</div>
                </div>
                }
                { loadingTeams && <LoadingDots/>}
              </div>
            </div>  
            <div className="right-side">
              <div className="selection-section user-section">
                <div className="label">{this.textMap.selectedMember}</div>
                <SelectMemberList 
                  members={selectedMembers} 
                  selectMember={this.props.handleRemoveMember} 
                />
                <div className="instructions">{'Click to Remove'}</div>
              </div>
              </div>
            </div>  
   );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default withRouter(connect(mapStateToProps)(TeamMembers));



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/SelectProjectMemberPopup/TeamMembers/index.js